import { useEffect, useState } from "react";
import { Diario } from "../../../interfaces/entities/UnimedAcolhe/Diario";
import { defaltAcceptTerm, defaltTerm, defaultDiary } from "./defaultStates";
import LoadingApp from "../../../components/LoadingApp";
import { getDiario, getDiarioQuestoes, getHistoricDataDiario, getMostrarNovamenteDiario, salvarRespostaQuestionario } from "../../../services/SaudeBemEstar/MeuDiarioService";
import './styles.css'
import MyDiary from "./MyDiary";
import { MyDiaryStepsEnum } from "../../../interfaces/enum/MyDiaryStepsEnum";
import { useNavigate, useParams } from "react-router-dom";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import Historic from "./Historic";
import { RetornaAceiteTermoResponse } from "../../../interfaces/entities/RetornaAceiteTermoResponse";
import { TermoResponsabilidade } from "../../../interfaces/entities/TermoResponsabilidade";
import { aceitaTermoResponsabilidade, retornaAceiteSaudeEmocional, retornaTermoResponsabilidadeSaudeEmocional } from "../../../services/TermoResponsabilidadeService";
import Symptoms from "./Symptoms";
import { MeuDiarioQuestoes } from "../../../interfaces/entities/UnimedAcolhe/MeuDiarioQuestoes";
import { HistoricoMeuDiario } from "../../../interfaces/entities/UnimedAcolhe/HistoricoMeuDiario";
import { MeuDiarioTipoQuestEnum } from "../../../interfaces/enum/MeuDiarioTipoQuestEnum";
import { aceiteNaoMostrarNovamente } from "../../../services/SaudeBemEstar/SaudeEmocionalService";
import { CircularProgress } from "@mui/material";
import ModalActionResponsive from "../../../components/ModalActionResponsive";
import PageTitle from "../../../components/Accessibility/PageTitle";


function MeuDiario(){
    const [diary, setDiary] = useState<Diario>(defaultDiary);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [step, setStep] = useState<MyDiaryStepsEnum>(MyDiaryStepsEnum.loading);
    const [acceptTerm, setAcceptTerm] = useState<RetornaAceiteTermoResponse>(defaltAcceptTerm);
    const [acceptDiary, setAcceptDiary] = useState<RetornaAceiteTermoResponse>(defaltAcceptTerm);
    const [term, setTerm] = useState<TermoResponsabilidade>(defaltTerm);
    const [questions, setQuestions] = useState<MeuDiarioQuestoes[]>([]);
    const [historic, setHistoric] = useState<HistoricoMeuDiario[]>([]);
    const [modalAction, setModalAction] = useState<null | {
        handleShowModal?: () => void; textOutlinedButton: string; textContainedButton: string;
        title: string; subTitle?: string; handleOutlinedButton?: () => void; handleContainedButton?: () => void; icon: "error" | "success" | "warning"
    }>(null);
    
    const {params} = useParams();
    const accessibility = useAccessibility();
    const navigate = useNavigate(); 

    useEffect(() => {
        Promise.all([
            getDiario(),
            getHistoricDataDiario(),
            retornaTermoResponsabilidadeSaudeEmocional(),
            retornaAceiteSaudeEmocional(),
            getDiarioQuestoes(),
            getMostrarNovamenteDiario()
        ]).then(results => {
            if(results[0] !== null && results[1] !== null && results[2] !== null && results[3] !== null && results[4] !== null && results[5] !== null){
                setDiary(results[0])
                setHistoric(results[1])
                setTerm(results[2])
                setAcceptTerm(results[3])
                setQuestions(results[4])
                setAcceptDiary(results[5])
                setLoading(false)
                setStep(MyDiaryStepsEnum.inicio)
            }
        })

        setLoading(true)
    }, []);

    useEffect(() => {
        if(params !== undefined){
            switch (params) {
                case MyDiaryStepsEnum.historico:
                    setStep(MyDiaryStepsEnum.historico)
                    break;
                case MyDiaryStepsEnum.sintomas:
                    setStep(MyDiaryStepsEnum.sintomas)
                    break;
                default:
                    setStep(MyDiaryStepsEnum.inicio)
                    break;
            }
        }
    }, [params]);

    const handleStart = () => {
        if(acceptDiary.indAceite === 'S'){
            setStep(MyDiaryStepsEnum.sintomas)
        }
        else {
            setStep(MyDiaryStepsEnum.historico)
        }
    }

    const handleTerms = async () => {
        var newAcceptTerm = acceptTerm;
        newAcceptTerm.indAceite = 'S';
        setAcceptTerm(newAcceptTerm);
        const result = await aceitaTermoResponsabilidade(`${acceptTerm.idTermoResponsabilidade}`, 'S');

        if(result !== null){
            setShowLoading(false);
        }
    }

    const handleNotShowHistoric = async () => {
        var newAcceptDiary = acceptDiary;
        newAcceptDiary.indAceite = 'S';
        setAcceptDiary(newAcceptDiary);

        const result = await aceiteNaoMostrarNovamente(acceptDiary.idTermoResponsabilidade, acceptDiary.idOperador);

        if(result !== null){
            setShowLoading(false);
        }
    }

    const handleHistoric = async (acceptedTerm: boolean, notShowHistoric: boolean) => {
        if(acceptedTerm) {
            setShowLoading(true);
            await handleTerms();
        }
        if(notShowHistoric){
            setShowLoading(true);
            await handleNotShowHistoric();
        }
        setStep(MyDiaryStepsEnum.sintomas)
        
    }

    const handleBack = () => {
        setStep(MyDiaryStepsEnum.inicio)
    }

    const handleStymptomsAnswer = (newQuestion: MeuDiarioQuestoes , questionIndex: number) => {
        const newQuestions = questions;
        newQuestions[questionIndex] = newQuestion;
        setQuestions(newQuestions);
    }

    const handleRadios = (question: MeuDiarioQuestoes, index: number) => {
        const answer = question.resposta;
        var newList = question.lstQuestoesTriagem.filter(obj => obj.vlrItem === answer);
        var newQuestions = questions;
        newQuestions[index].lstQuestoesTriagem = newList;
        setQuestions(newQuestions)
    }

    const handleCheckboxes = (question: MeuDiarioQuestoes, index: number) => {
        var newList = question.lstQuestoesTriagem.filter(obj => obj.resposta === 'S');
        var newQuestions = questions;
        newQuestions[index].lstQuestoesTriagem = newList;
        setQuestions(newQuestions)
    }

    const handleSymptoms =  () => {
        const asnwers = questions;

        asnwers.forEach((question, index) => {
            if(question.codTipoQuestaoTeleOrient === MeuDiarioTipoQuestEnum.radio){
                handleRadios(question, index);
            }
            else if(question.codTipoQuestaoTeleOrient === MeuDiarioTipoQuestEnum.checkbox){
                handleCheckboxes(question, index);
            }
        })

        saveQuiz();
    }

    const saveQuiz = async () => {
        setShowLoading(true);
        await salvarRespostaQuestionario(questions).then(result => {
            setShowLoading(false)
            openSucessModal();
        });

    }

    const openSucessModal = () => {
        setModalAction({
            title: "Diário registrado com sucesso!",
            subTitle: "Você gostaria de ler algumas dicas que podem te auxiliar?",
            textOutlinedButton: 'TALVEZ EM OUTRO MOMENTO',
            textContainedButton: 'VAMOS LÁ',
            handleContainedButton: handleLetsGo,
            handleOutlinedButton: handleAnotherMoment,
            handleShowModal: handleAnotherMoment,
            icon: 'success'
        })
    }

    const handleLetsGo = () => {
        window.open('https://www.unimedcampinas.com.br/blog/saude-emocional', '_blank');
        handleCloseModalAction();
        navigate('/saudeBemEstar/unimedAcolhe/inicio');
    }

    const handleAnotherMoment = () => {
        handleCloseModalAction();
        navigate('/saudeBemEstar/unimedAcolhe/inicio');
    }

    const handleCloseModalAction = () => {
        setModalAction(null);
    }

    return (
        <div className="my-diary-holder">
            <LoadingApp showLoading={showLoading} />
            <PageTitle text="Meu diário" />
            {loading && 
                <div className="loading-holder">
                    <CircularProgress />
                </div>
            }
            {!loading && step === MyDiaryStepsEnum.inicio && 
                <MyDiary 
                    diary={diary} 
                    handleStart={handleStart} 
                    historic={historic}
                    acceptDiary={acceptDiary}/>}
            {!loading && step === MyDiaryStepsEnum.historico && 
                <Historic 
                    diary={diary} 
                    handleHistoric={handleHistoric} 
                    handleHistoricBack={handleBack}
                    acceptTerm={acceptTerm}
                    term={term}/>
            }
            {!loading && step === MyDiaryStepsEnum.sintomas && 
                <Symptoms 
                    questions={questions}
                    handleStymptomsBack={handleBack} 
                    handleStymptomsAnswer={handleStymptomsAnswer}
                    handleSymptoms={handleSymptoms}/>
            }
            <ModalActionResponsive
                showModal={!!modalAction}
                handleShowModal={modalAction?.handleShowModal}
                icon={modalAction?.icon}
                textOutlinedButton={modalAction?.textOutlinedButton || ''}
                textContainedButton={modalAction?.textContainedButton || ''}
                title={modalAction?.title || ''}
                subTitle={modalAction?.subTitle || ''}
                handleOutlinedButton={modalAction?.handleOutlinedButton}
                handleContainedButton={modalAction?.handleContainedButton}
                width="max-content"
            />
        </div>
    )
}

export default MeuDiario;